import moment from "moment";

export const handleTime = () => {
    const time = new Date();
   let customizeTime = time.toLocaleString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        second: '2-digit',
        hour12: true 
      }) 
        return customizeTime;
  }


  export const handleCratedAt = (stateTime: any) => {
    let current_time = handleTime();

    // start time and end time
    var startTime = moment(stateTime, "HH:mm:ss a");

    var endTime = moment(current_time, "HH:mm:ss a");

    // calculate total duration
    var duration = moment.duration(endTime.diff(startTime));

    // duration in hours
    var hours = parseInt(duration.asHours().toString());

    // duration in minutes
    var minutes = parseInt(duration.asMinutes().toString()) % 60;

    if (hours > 1) {  
       return current_time;
    } else {
        return null;
    }
}
